import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ocean-fright-service',
  templateUrl: './ocean-fright-service.component.html',
  styleUrls: ['./ocean-fright-service.component.scss']
})
export class OceanFrightServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
